import React from 'react';
import { Box,Stack, Typography } from '@mui/material';

import HorizontalScrollbar from './HorizontalScrollbar';
import Loader from './Loader';

const SimilarExercices = ({targetMuscleExercices, equipmentExercices}) => {
  return (
    <Box sx={{mt:{lg:'100px', xs:'0'}}}>
        <Typography variant="h3" mb={3}>
        Exercice qui cible le même groupe musculaire
        </Typography>
        <Stack direction="row" sx={{p:"2", position:'relative'}}>
            {targetMuscleExercices.length ? <HorizontalScrollbar data={targetMuscleExercices} /> 
                : <Loader /> }
        </Stack>
        <Typography variant="h3" mb={3}>
        Exercice qui utilise le même equipement 
        </Typography>
        <Stack direction="row" sx={{p:"2", position:'relative'}}>
            {equipmentExercices.length ? <HorizontalScrollbar data={equipmentExercices} /> 
                : <Loader /> }
        </Stack>
    </Box>
  )
}

export default SimilarExercices